// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  padding: 0;
  margin: 4px 0;
}

ion-card {
  padding: 8px;
  margin: 0;
  cursor: pointer;
  box-shadow: none;
}

ion-card-title {
  display: flex;
  font-size: var(--font-size-large-1);
}
ion-card-title .article-title {
  font-weight: var(--font-weight-medium);
  font-style: normal;
  font-size: var(--font-size-large);
  line-height: var(--font-line-height-large);
  color: var(--mi-secondary-color-2);
  flex-grow: 1;
}
ion-card-title .article-image {
  width: 75px;
  height: 75px;
  border-radius: 10px;
  flex-shrink: 0;
}

app-chips {
  --padding-bottom: 10px;
}
app-chips app-text-chip {
  --color: var(--mi-secondary-color-2);
  --background-color: var(--mi-blue-color-4);
  --font-size: var(--font-size-tiny);
}

.score {
  font-style: italic;
  font-weight: lighter;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
